module.exports = __webpack_public_path__ + "static/img/3.b9440f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/3.png
// module id = KhNA
// module chunks = 0